import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { DeviceService } from 'src/app/services/device.service';
import { UserDataService } from 'src/app/services/user-data.service';
@Component({
  selector: 'app-cervezas',
  templateUrl: './cervezas.component.html',
  styleUrls: ['./cervezas.component.css']
})
export class CervezasComponent {

  clients: any[] = []; //Información básica los clientes
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['id', 'name', 'clientName', 'created_at', 'updated_at', 'operaciones'];
  dataSource :any;
  cervezaData: any [] = []; //Información de los clientes
  tiempoEsperaRecarga: number = 60000; //Despues del error 429 se esperan 60 segundos para recargar la página
  numeroClientes: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroClientes];
  userData: any = [];

  private clientsSubscription: Subscription | undefined;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private deviceService: DeviceService, private router: Router, private error429: Error429Service, 
    private userDataService: UserDataService){
      this.userData = this.userDataService.getUserData();
    }
  
  ngOnInit(): void {
    if(this.userData.pro_id != "4"){
      this.displayedColumns = ['id', 'name', 'created_at', 'updated_at', 'operaciones'];
    }
    this.clientsSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          //this.cervezaData.push(resp[i]);
          this.cervezaData.push({
            id: resp[i].id,
            name: resp[i].name,
            clientName: resp[i].cliente.razon_social,
            created_at: resp[i].created_at,
            updated_at: resp[i].updated_at
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.dataSource = new MatTableDataSource(this.cervezaData); 
        this.datosRecibidos = true; 
        this.numeroClientes = this.cervezaData.length;
        //this.pageSizeOptions = [ Math.floor(this.numeroClientes/2), this.numeroClientes];
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        },0)
      }
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  //Función para convertir la fecha
  formatDateTime(dateTimeString: string | null): string {
    if (dateTimeString !== null) {
      const inputDate = new Date(dateTimeString);
      const year = inputDate.getFullYear();
      const month = ('0' + (inputDate.getMonth() + 1)).slice(-2);
      const day = ('0' + inputDate.getDate()).slice(-2);
      const hours = ('0' + inputDate.getHours()).slice(-2);
      const minutes = ('0' + inputDate.getMinutes()).slice(-2);
      const seconds = ('0' + inputDate.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
  }

  //Funciones para actualizar la página actual despues de un tiempoEsperaRecarga
  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  descargarExcel(){
    console.log(this.cervezaData);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Código', key: 'codigo', width: 10 },
      { header: 'Nombre', key: 'name', width: 30 },
      { header: 'Cliente', key: 'cliente', width: 30 },
      { header: 'Fecha Alta', key: 'creado', width: 30 },
      { header: 'Modificado', key: 'modificado', width: 30 },
    ];
    /*this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });*/
    this.cervezaData.forEach(cerveza => {
      const formattedCliente = {
        codigo: cerveza.id,
        name: cerveza.name,
        cliente: cerveza.clientName,
        creado: this.formatDateTime(cerveza.created_at),
        modificado: this.formatDateTime(cerveza.created_at),
      };
      const row = worksheet.addRow(formattedCliente);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado productos DataBeer.xlsx');
    });
  }
}
